<template>
  <div id="login-bg">
    <div class="mast"></div>
    <div class="login-box login-bar-fade-in">
      <h2>黔诚在线管理平台</h2>
      <el-form :rules="rules" ref="loginForm" :model="ma">
        <el-form-item prop="mobile">
          <el-input prefix-icon="el-icon-mobile-phone" :maxlength="11" v-model="ma.mobile" type="text"
                    placeholder="请输入手机号码" :clearable="true"></el-input>
        </el-form-item>
        <!--        <el-form-item prop="pwd">
                  <el-input prefix-icon="el-icon-key" type="password" v-model="ma.pwd" placeholder="请输入密码"></el-input>
                </el-form-item>-->
        <el-form-item prop="pwd">
          <el-col :span="12">
            <el-input prefix-icon="el-icon-key" :clearable="true" :maxlength="8" type="text" v-model="ma.pwd"
                      placeholder="请输入验证码"></el-input>
          </el-col>
          <el-col :span="11" :offset="1">
            <el-button v-if="countdown <= 0" style="width: 100%" ref="btnVerifyCode" @click.stop="getVerifyCode">获取验证码
            </el-button>
            <el-button v-else style="width: 100%" ref="btnVerifyCode" disabled>{{ countdown }}秒后获取验证码</el-button>
          </el-col>
        </el-form-item>
        <el-form-item class="btnLogin">
          <el-button type="primary" style="width: 100%" @click="authc">登录</el-button>
          <!--                    <el-button type="primary" style="width: 100%" @click="login">测试版登录</el-button>-->
        </el-form-item>
        <el-form-item>
          <div id="captcha"></div>
        </el-form-item>
      </el-form>
      <div class="record-num">
        <a href="https://beian.miit.gov.cn/" target="_blank">黔ICP备20000894号-1</a>
        <br>
        <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">贵公网安备52010202003934号</a>
      </div>
    </div>
  </div>
</template>

<script>
import validator from "@/common/Validator";

export default {
  name: "Login",
  data() {
    const checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      } else if (!validator.isPhone(value)) {
        return callback(new Error('请输入正确的手机号'));
      } else {
        return callback();
      }
    };
    return {
      apiUrl: process.env.VUE_APP_URL,
      disabled: true,
      countdown: 0,
      ma: {
        mobile: "",
        pwd: ""
      },
      rules: {
        mobile: [
          // {required: true, message: '请输入手机号', trigger: 'blur'},
          {validator: checkMobile, trigger: 'blur'}
          // {type: 'string', pattern: /^\d{11}$/, message: '手机号码格式不对', trigger: 'blur'}
        ],
        pwd: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          // {type: 'string', pattern: /^\d{5,7}$/, message: '验证码格式不对', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    authc() {
      /*
      2、恢复人机验证，打开注释
      var params = 'code=' + getNVCVal();
      this.asfCheck(this.apiUrl + 'afsCheck', params);
      */
      this.login();
    },
    /*
    3、恢复人机验证，打开注释（恢复人机验证客户端要打开3处注释）
    asfCheck(url, params) {
        var callbackName = ('jsonp_' + Math.random()).replace('.', '');
        params += '&callback=' + callbackName;
        var o_scripts = document.getElementsByTagName("script")[0];
        var o_s = document.createElement('script');
        o_scripts.parentNode.insertBefore(o_s, o_scripts);
        //您注册请求的业务回调
        window[callbackName] = this.$axios.post(url, params).then(({data}) => {
            let code = parseInt(data);
            if (code === 400) {
                //唤醒滑动验证
                getNC().then(function () {
                    _nvc_nc.upLang('cn', {
                        _startTEXT: "请按住滑块，拖动到最右边",
                        _yesTEXT: "验证通过",
                        _error300: "哎呀，出错了，点击<a href=\"javascript:__nc.reset()\">刷新</a>再来一次",
                        _errorNetwork: "网络不给力，请<a href=\"javascript:__nc.reset()\">点击刷新</a>",
                    })
                    _nvc_nc.reset()
                })
            } else if (code === 600) {
                //唤醒刮刮卡
                getSC().then(function () {
                });
            } else if (code === 700) {
                //唤醒问答验证码
                getLC();
            } else if (code === 100 || code === 200) {
                //注册成功
                nvcReset();
                this.login();
            } else if (code === 800 || code === 900) {
                //直接拦截
                nvcReset();
            }
            o_s.src = url + '?' + params
        });
    },*/
    getVerifyCode() {
      if (validator.isPhone(this.ma.mobile)) {
        this.$axios.post(
            this.apiUrl + "sendVerifyCode",
            this.ma
        ).then(response => {
          let statusCode = response.data.code;
          if (statusCode === 212) {
            this.$message.error('验证码发送失败');
          } else if (statusCode === 6404) {
            this.$message.warning('不支持该手机号登录');
          } else if (statusCode === 200) {
            this.$message.success('验证码已发送，请查看手机')
            this.countdown = 60;
            const interval = setInterval(() => {
              if (this.countdown <= 0) {
                clearInterval(interval);
              }
              this.countdown--;
            }, 1000)
          }
        })
      }
    },
    login() {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(
              this.apiUrl + "login",
              this.ma
          ).then(response => {
            let statusCode = response.data.code;
            if (statusCode === 212) {
              this.$message.error('验证码错误，请核对');
            } else if (statusCode === 211) {
              this.$message.warning('你的账号已被系统锁定，请2小时候后再试');
            } else if (statusCode === 200) {
              let loginInfo = JSON.parse(response.data.message);
              localStorage.setItem("token", loginInfo.token);
              localStorage.setItem("perm", loginInfo.perm.join(","));
              localStorage.setItem("userName", this.ma.mobile);
              this.$router.push("/main");
            }
          })
        } else {
          return false;
        }
      })
    }
  }
}
</script>

<style scoped>
.record-num {
  text-align: center;
  padding-bottom: 10px;
}

.record-num a {
  color: #6f6f6f;
  font-size: 0.86em;
}

#login-bg {
  background: url("../assets/banner-1.jpg") no-repeat center;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.mast {
  width: 100vw;
  height: 100vh;
  background: black;
  opacity: 0.5;
  position: absolute;
}

.login-bar-fade-in {
  animation: bounceInDown 2s;
}

h2 {
  text-align: center;
  color: #e79b37;
  padding: 30px 0 0 0;
}

.mobile {
  margin-bottom: 10px;
}

.login-box {
  width: 100%;
  /*height: 300px;*/
  background: #f8f8f8;
  opacity: 0.8;
  /*border-bottom-left-radius: 6px;*/
  /*border-top-left-radius: 6px;*/
  /*margin-bottom: 40px;*/
}

/*
.el-form-item {
     margin: 5px 0;
     padding: 0;
 }

 .btnLogin {
     margin-top: 35px;
 }
*/
.el-form {
  width: 400px;
  padding: 20px 0 0 0;
  margin: 0 auto;
}

</style>